export const LOADING = 'addEditListicle.LOADING';
export const LOADED = 'addEditListicle.LOADED';